module.exports = __webpack_public_path__ + "static/media/JAGStyleGuide.e0634db7.png";